<template>
  <div class="wrapper">
    <div class="summarization-report-header">
      <i
        class="icon fas fa-arrow-circle-left"
        @click="$router.go(-1)"
        />
      <div class="summarization-report-header-label">
        Sumarização
      </div>
    </div>
    <div class="summarization-summary-board">
      <div class="summarization-report-summary">
        <div class="summarization-report-summary-text-container">
          <div class="summarization-report-summary-header">
            Resumo de análise
          </div>
          <div class="summarization-report-summary-text">
            O Resultado abaixo é baseado nos comentários realizados entre o período de
            <strong> {{ startDate }} a {{ endDate }}</strong>
            considerando uma amostra de comentários de
            <strong>{{ totalAnswers }} respostas</strong>
            utilizando Inteligência artificial para interpretação dos dados.
          </div>
        </div>
      </div>
    </div>
    <div class="summarization-board-column-container">
    <div
      v-if="displayMode === 'board'"
      class="summarization-board"
    >
      <div class="summarization-board-line">
        <div class="summarization-two-columns">
          <div class="result-box">
            <div class="result-label">
              <div class="result-label-text">
                Resultado
              </div>
            </div>
            <div class="result-line">
              <hr />
            </div>
            <div class="result-text-description">
              <div class="summarization-description-item"
                v-for="(item, indexSummarization) in summarizations.results"
                :key="indexSummarization"
              >
                <div class="summarization-description-item-number">
                  {{ indexSummarization + 1 }}.
                </div>
                <div>
                  <strong>{{ item.title }} -</strong>
                  <label>
                    {{ item.summary }}
                  </label>
                  <br>
                  {{ item.description }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="summarization-footer">
      *Lembre-se de que esta análise é simplificada e baseada no texto fornecido.
      Em uma situação real, uma análise SWOT seria muito mais detalhada e
      levaria em consideração várias outras variáveis.
    </div>
    </div>
  </div>
</template>

<script>
// import { mapState } from 'vuex';
// import api from '../../../../../../services/api';

export default {
  data: () => ({
    startDate: '01/01/2023',
    endDate: '27/09/2023',
    totalAnswers: 8527,
    displayMode: 'board',
    selectedColumnColor: '#BABABA',
    selectedBoardColor: '#5E5E5E',
    summarizations: {
      results: [
        {
          title: 'Atendimento',
          summary: 'Quantidade de Comentários: 1344 - Sentimento: Positivo',
          description: 'O atendimento ao cliente é altamente valorizado e frequentemente mencionado de forma positiva nos feedbacks.',
        },
        {
          title: 'Rapidez',
          summary: 'Quantidade de Comentários: 532 - Sentimento: Positivo',
          description: 'A rapidez no atendimento ou na resolução de problemas é valorizada pelos clientes.',
        },
        {
          title: 'Qualidade Geral',
          summary: 'Quantidade de Comentários: 478 (bom) + 360 (excelente) - Sentimento: Positivo',
          description: 'A qualidade geral do serviço é frequentemente descrita como "bom" ou "excelente" pelos clientes.',
        },
        {
          title: 'Satisfação do Cliente',
          summary: 'Quantidade de Comentários: 355 (gostei) - Sentimento: Positivo',
          description: 'Muitos clientes expressam sua satisfação com o serviço, usando palavras como "gostei".',
        },
        {
          title: 'Atendentes',
          summary: 'Quantidade de Comentários: 242 (gostei) - Sentimento: Positivo',
          description: 'Os atendentes são frequentemente elogiados pelos clientes, indicando que a interação com a equipe é positiva. ',
        },
      ],
    },
  }),

  computed: {
  },

  watch: {
  },

  methods: {
    setBoardDisplayMode() {
      this.selectedBoardColor = '#5E5E5E';
      this.selectedColumnColor = '#BABABA';
      this.displayMode = 'board';
    },
    setColumnDisplayMode() {
      this.selectedBoardColor = '#BABABA';
      this.selectedColumnColor = '#5E5E5E';
      this.displayMode = 'column';
    },
  },

  async mounted() {
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.summarization-report-header {
  padding: 10px;
  display: flex;
  .summarization-report-header-label {
    padding-left: 12px;
    color: #242424;
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: Segoe UI;
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 109.091% */ 
  }
  .fa-arrow-circle-left {
    cursor: pointer;
  }
}
.summarization-summary-board {
  display: flex;
  background: white;
  margin: 10px;
}
.summarization-report-summary {
  margin: 10px;
  display: flex;
  padding: 24px;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch; 
  border-radius: 4px;
  background: #FFF;
}
.summarization-report-summary-text-container {
  display: flex;
  width: 952px;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px; 
}
.summarization-report-summary-header {
  color: #242424;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Segoe UI;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 109.091% */ 
}
.summarization-report-summary.text {
  color: #333;
  text-align: justify;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Segoe UI;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal; 
}
.summarization-report-summary-icon-container {
  width: 100%;
  align-items: center;
  justify-content: end;
  display: flex;
  padding-right: 24px;
}
.summarization-svg-container {
  cursor: pointer;
}
.icon {
  color: #3DB374;
  font-size: 20px;
}
.display-flex {
  display: flex;
}
.summarization-board-column-container {
  margin: 20px 10px;
  background: #FFF;
  padding-bottom: 16px;
}
.summarization-column,
.summarization-board {
  display: flex;
  padding: 16px 0px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  flex: 1 0 0;
  border-radius: 4px;
}
.summarization-board .summarization-board-line {
  display: block;
  padding: 12px;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  border-radius: 4px;
  background: #FFF;
  /* Default shadow */
  box-shadow: 0px 2px 6px 0px rgba(41, 70, 97, 0.20);
}
.summarization-two-columns {
  display: flex;
  padding: 12px;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
}
hr {
  width: 102px;
  height: 6px;
  border: none;
  // position: absolute;
  margin: 8px 0px 20px 0px;
}
.result-box {
  width: 50%;
}
.result-label {
  display: flex;
  align-items: center;
  gap: 12px;
  align-self: stretch; 
}
.result-label-text {
  color: #242424;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Segoe UI;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px; /* 100% */ 
}
.fa-dumbbell {
  color: #236642;
}
.fa-unlink {
  color: #992215;
}
.fa-bullseye {
  color: #527BF2;
}
.fa-exclamation-triangle {
  color: #FCBE30;
}
.result-line {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
}
.result-line {
  flex-direction: column;
}
.result-line hr {
  background: #4DE594;
}
.result-text-description {
  align-self: stretch;
  color: #333;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Segoe UI;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  padding-top: 12px;
  strong {
    font-weight: 700;
  }
  label {
    color: #808080;
    margin-bottom: 0;
  }
  li {
    padding-bottom: 10px;
  }
}
.result-text-description ol {
  padding-left: 20px;
}
.summarization-description-item {
  display: flex;
  padding-bottom: 10px;
}
.summarization-description-item-right {
  display: block;
  padding-bottom: 10px;
}
.summarization-description-item-number {
  padding-right: 10px;
}
.summarization-footer {
  align-self: stretch;
  color: #808080;
  text-align: center;
  font-family: Segoe UI;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.summarization-column-card-container {
  width: 100%;
  display: flex;
  padding: 24px 14px;
}
.summarization-column-card {
  display: block;
  width: 25%;
  margin: 0px 10px;
  justify-content: center;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 4px;
  background: #FFF;
  /* Default shadow */
  box-shadow: 0px 2px 6px 0px rgba(41, 70, 97, 0.20);
}
.summarization-column-card-header {
  width: 100%;
  display: flex;
  padding: 12px 0px;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  align-self: stretch; 
}
.summarization-column-card-header-icon {
  font-size: 26px;
}
.summarization-column-card-header-label {
  color: #242424;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Segoe UI;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px; /* 80% */
}
.summarization-column-card-header-result {
  background: #E2F4EA; 
}
.summarization-column-description-card {
  display: block;
  padding: 12px 12px 24px 12px;
  align-items: flex-start;
  gap: 6px;
  align-self: stretch;
  font-size: 14px;
}
.summarization-column-description-item {
  display: flex;
  padding-bottom: 6px;
}
.summarization-board-logo {
  text-align: center;
  img {
    width: 65px;
    z-index: 1;
    position: relative;
  }
  hr {
    background: #D9D9D9;
    width: 100%;
    height: 1px;
    position: relative;
    top: 32px;
    margin: 0px;
    z-index: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/reports/ai-analysis/ai-summarization-reports/summarization-view/index.vue